
export const state = {
    rolemodules: []
}

export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/rolemodules/state.js